
import classes from './FamilyLayout.module.scss'
import { Navigate, NavLink, Outlet, useLocation, useParams } from 'react-router-dom'
import classNames from 'classnames'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFamily } from '../../actions/familyActions'

import { ReactComponent as StarIcon } from '../../assets/images/common/icons/star-icon.svg'
import { deserialize } from '../../utility/serialization'
// import Loader from '../common/loader/Loader'
import StudentWithAvatar from '../students/StudentWithAvatar'


const FamilyLayout = () => {
  const location = useLocation()
  const abortController = useRef(null)
  const dispatch = useDispatch()
  const { familyId } = useParams()

  const family = useSelector(state => state.family)

  useEffect(() => {
    abortController.current = new AbortController()

    if (familyId) {
      dispatch(getFamily(familyId, abortController.current?.signal))
    }

    return () => abortController.current.abort()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [familyId])

  // TODO: Validate familyId
  if (!familyId) {
    return <Navigate to='/members/families' replace />
  }

  // if (!family?.length) {
  //   return (
  //     <div className='h-100 d-flex align-items-center justify-content-center'>
  //       <Loader>Loading Family</Loader>
  //     </div>
  //   )
  // }

  return (
    <div className={classes.familyWrapper}>
      <header>
        <div className={classes.title}>
          <h2 className='font-weight-bold mb-1'>{family.name}</h2>
          <div className={classes.points}>
            <StarIcon width={15} height={15} color='white' />
            <p className='mb-0 font-weight-bold'>{family.points}pts</p>
          </div>
        </div>
        <div className={classes.totalRevenue}>
          <span>Revenue</span>
          <h1>${family.revenue}</h1>
        </div>
        <div className={classes.familyMembers}>
          {family.users?.map(user => (
            <div key={user.id} className={classes.familyMember}>
              <div className={classes.avatarWrapper}>
                <StudentWithAvatar student={user} avatarClassName={classes.membersAvatar} />
              </div>
              <span className={classes.membersInitials}>{user.first_name.at(0)}{user.last_name.at(0)}</span>
            </div>
          ))}
        </div>
      </header>
      <nav>
        <NavLink to='enrollments' replace state={location.state}>
          {({ isActive }) => (
            <button className={classNames('subHeaderTab', { active: isActive })}>Enrollments</button>
          )}
        </NavLink>
        <NavLink to='contact' replace state={location.state}>
          {({ isActive }) => (
            <button className={classNames('subHeaderTab', { active: isActive })}>Contact Information</button>
          )}
        </NavLink>
      </nav>
      {/* TODO: Change this before prod */}
      <Outlet context={{ family: deserialize(family) }} />
    </div>
  )
}

export default FamilyLayout
